import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import Logo from '../../images/logo-wbg.svg'
import CompanyForm from '../../components/CompanyForm';

const RegisterWith =() => {
    return(
        <Fragment>
            <Navbar Logo={Logo}/>
            {/* <PageTitle pageTitle={'Service'} pagesub={'Service'}/>  */}
            <CompanyForm TopPadding={"180px"}/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default RegisterWith;

